/* Miayaa verified reviews: product review form (+ email code), lightbox, "show more" and reviews wall tabs.
   Idempotent: safe to load on several sections and to re-run after theme editor re-renders. */
(function () {
  'use strict';

  var MAX_FILES = 5;
  var MAX_IMAGE = 8 * 1024 * 1024;
  var MAX_VIDEO = 50 * 1024 * 1024;
  var IMAGE_MAX_EDGE = 1600;

  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z"/></svg>';
  var ICON_SHIELD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7.5 3v5.5c0 4.6-3.2 8.2-7.5 9.5-4.3-1.3-7.5-4.9-7.5-9.5V6z"/><path d="M8.8 12.2l2.2 2.2 4.2-4.4"/></svg>';
  var STAR = '<path d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.3L12 17.1l-5.7 3.1 1.2-6.3L2.8 9.5l6.4-.8z"/>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- product review form ---------------- */
  function initReviews(root) {
    if (root.dataset.mxrInit) return;
    root.dataset.mxrInit = '1';

    var api = (root.dataset.api || '').replace(/\/$/, '');
    var panel = root.querySelector('[data-mxr-panel]');
    var form = root.querySelector('[data-mxr-form]');
    var steps = {
      form: root.querySelector('[data-mxr-step="form"]'),
      otp: root.querySelector('[data-mxr-step="otp"]'),
      done: root.querySelector('[data-mxr-step="done"]')
    };
    var writeBtns = root.querySelectorAll('[data-mxr-write]');
    var alertEl = root.querySelector('[data-mxr-alert]');
    var submitBtn = root.querySelector('[data-mxr-submit]');
    var progress = root.querySelector('[data-mxr-progress]');
    var fileInput = root.querySelector('[data-mxr-files]');
    var drop = root.querySelector('[data-mxr-drop]');
    var previews = root.querySelector('[data-mxr-previews]');
    var files = [];
    var reviewId = null;
    var timer = null;
    var expiresAt = 0;
    var resendAt = 0;

    function show(step) {
      Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== step; });
    }

    writeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        writeBtns.forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
        if (open) {
          panel.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
          var first = panel.querySelector('input[name="rating"]');
          if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
        }
      });
    });

    /* stars */
    var starWrap = root.querySelector('[data-mxr-stars]');
    var word = root.querySelector('[data-mxr-word]');
    var radios = starWrap.querySelectorAll('input');
    var labels = starWrap.querySelectorAll('label');
    function paint(n) {
      labels.forEach(function (l, i) { l.classList.toggle('is-on', i < n); });
    }
    function selected() {
      var c = starWrap.querySelector('input:checked');
      return c ? parseInt(c.value, 10) : 0;
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        paint(selected());
        word.textContent = r.dataset.word;
        clearError('rating');
      });
    });
    labels.forEach(function (l, i) {
      l.addEventListener('mouseenter', function () { paint(i + 1); word.textContent = radios[i].dataset.word; });
    });
    starWrap.addEventListener('mouseleave', function () {
      var n = selected();
      paint(n);
      word.textContent = n ? radios[n - 1].dataset.word : '';
    });

    /* character count */
    var body = form.querySelector('textarea[name="body"]');
    var count = root.querySelector('[data-mxr-count]');
    body.addEventListener('input', function () {
      count.textContent = body.value.length + ' / 2000' + (body.value.trim().length < 20 ? ' (at least 20 characters)' : '');
    });

    /* files */
    function addFiles(list) {
      clearError('media');
      Array.prototype.forEach.call(list, function (f) {
        var isVideo = /^video\//.test(f.type);
        var isImage = /^image\//.test(f.type) || /\.(heic|heif)$/i.test(f.name);
        if (!isVideo && !isImage) return setError('media', 'Please choose photos (JPG, PNG, WebP, HEIC) or a video (MP4, MOV, WebM).');
        if (files.length >= MAX_FILES) return setError('media', 'You can add up to ' + MAX_FILES + ' photos or videos.');
        if (isVideo && files.some(function (x) { return x.video; })) return setError('media', 'You can add one video per review.');
        if (isVideo && f.size > MAX_VIDEO) return setError('media', 'Videos can be up to 50 MB. Try a shorter clip.');
        files.push({ file: f, video: isVideo, url: URL.createObjectURL(f) });
      });
      renderPreviews();
    }
    function renderPreviews() {
      previews.innerHTML = files.map(function (x, i) {
        var media = x.video
          ? '<video src="' + x.url + '#t=0.5" muted playsinline preload="metadata"></video>'
          : '<img src="' + x.url + '" alt="">';
        return '<li>' + media + '<button type="button" data-remove="' + i + '" aria-label="Remove file ' + (i + 1) + '">' + ICON_X + '</button></li>';
      }).join('');
    }
    previews.addEventListener('click', function (e) {
      var b = e.target.closest('[data-remove]');
      if (!b) return;
      var i = parseInt(b.dataset.remove, 10);
      URL.revokeObjectURL(files[i].url);
      files.splice(i, 1);
      renderPreviews();
    });
    fileInput.addEventListener('change', function () { addFiles(fileInput.files); fileInput.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer) addFiles(e.dataTransfer.files); });

    /* errors */
    function setError(field, msg) {
      var el = root.querySelector('[data-error-for="' + field + '"]');
      if (el) el.textContent = msg;
      var input = form.querySelector('[name="' + field + '"]');
      if (input && input.type !== 'radio' && input.type !== 'checkbox') input.setAttribute('aria-invalid', 'true');
    }
    function clearError(field) {
      var el = root.querySelector('[data-error-for="' + field + '"]');
      if (el) el.textContent = '';
      var input = form.querySelector('[name="' + field + '"]');
      if (input) input.removeAttribute('aria-invalid');
    }
    form.addEventListener('input', function (e) { if (e.target.name) clearError(e.target.name); });
    function showAlert(el, msg) { el.textContent = msg; el.hidden = !msg; }

    function validate() {
      var ok = true;
      var v = function (n) { return (form.elements[n].value || '').trim(); };
      ['rating', 'name', 'city', 'email', 'body', 'consent'].forEach(clearError);
      if (!selected()) { setError('rating', 'Please choose a star rating.'); ok = false; }
      if (v('name').length < 2) { setError('name', 'Please enter your name.'); ok = false; }
      if (v('city').length < 2) { setError('city', 'Please enter your city.'); ok = false; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v('email'))) { setError('email', 'Please enter a valid email address.'); ok = false; }
      if (v('body').length < 20) { setError('body', 'Please write at least 20 characters.'); ok = false; }
      if (!form.elements.consent.checked) { setError('consent', 'Please tick the box to publish your review.'); ok = false; }
      if (!ok) {
        var firstErr = root.querySelector('.mxr-field__error:not(:empty)');
        if (firstErr) firstErr.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'center' });
      }
      return ok;
    }

    /* image compression: long edge 1600px JPEG; falls back to the original file */
    function compress(f) {
      if (f.video || !window.createImageBitmap || /heic|heif/i.test(f.file.type + f.file.name)) return Promise.resolve(f.file);
      return createImageBitmap(f.file).then(function (bmp) {
        var scale = Math.min(1, IMAGE_MAX_EDGE / Math.max(bmp.width, bmp.height));
        var c = document.createElement('canvas');
        c.width = Math.round(bmp.width * scale);
        c.height = Math.round(bmp.height * scale);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        return new Promise(function (res) {
          c.toBlob(function (b) {
            res(b && b.size < f.file.size ? new File([b], f.file.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }) : f.file);
          }, 'image/jpeg', 0.85);
        });
      }).catch(function () { return f.file; });
    }

    function post(path, data, onProgress) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', api + path);
        xhr.responseType = 'json';
        if (!(data instanceof FormData)) xhr.setRequestHeader('Content-Type', 'application/json');
        if (onProgress && xhr.upload) xhr.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded / e.total); };
        xhr.onload = function () {
          var res = xhr.response || {};
          if (xhr.status >= 200 && xhr.status < 300) resolve(res);
          else reject({ status: xhr.status, message: res.error || 'Something went wrong. Please try again.', field: res.field });
        };
        xhr.onerror = function () { reject({ status: 0, message: 'Network error. Please check your connection and try again.' }); };
        xhr.send(data instanceof FormData ? data : JSON.stringify(data));
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showAlert(alertEl, '');
      if (!validate()) return;
      submitBtn.disabled = true;
      submitBtn.textContent = files.length ? 'Uploading…' : 'Sending code…';

      Promise.all(files.map(function (f) { return compress(f); })).then(function (ready) {
        var tooBig = ready.filter(function (f) { return !/^video\//.test(f.type) && f.size > MAX_IMAGE; });
        if (tooBig.length) throw { message: 'Photos can be up to 8 MB each. Please choose a smaller photo.', field: 'media' };
        var fd = new FormData();
        ['product_id', 'name', 'city', 'email', 'body', 'website'].forEach(function (n) { fd.append(n, form.elements[n].value.trim()); });
        fd.append('rating', String(selected()));
        fd.append('consent', form.elements.consent.checked ? 'yes' : '');
        ready.forEach(function (f) { fd.append('media', f, f.name); });
        if (ready.length) progress.hidden = false;
        return post('/reviews/start', fd, function (p) {
          progress.firstElementChild.style.width = Math.round(p * 100) + '%';
        });
      }).then(function (res) {
        reviewId = res.id;
        root.querySelector('[data-mxr-email]').textContent = res.email;
        show('otp');
        startTimer(res.expiresIn || 600);
        var first = root.querySelector('[data-mxr-digit]');
        root.querySelector('[data-mxr-otp-title]').focus();
        setTimeout(function () { first.focus(); }, 50);
      }).catch(function (err) {
        if (err.field && root.querySelector('[data-error-for="' + err.field + '"]')) setError(err.field, err.message);
        else showAlert(alertEl, err.message || 'Something went wrong. Please try again.');
      }).then(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit and get code';
        progress.hidden = true;
        progress.firstElementChild.style.width = '0';
      });
    });

    /* code entry */
    var otpForm = root.querySelector('[data-mxr-otp-form]');
    var digits = root.querySelectorAll('[data-mxr-digit]');
    var otpAlert = root.querySelector('[data-mxr-otp-alert]');
    var verifyBtn = root.querySelector('[data-mxr-verify]');
    var resendBtn = root.querySelector('[data-mxr-resend]');
    var timerEl = root.querySelector('[data-mxr-timer]');

    function code() { return Array.prototype.map.call(digits, function (d) { return d.value; }).join(''); }
    function fill(str) {
      var s = (str || '').replace(/\D/g, '').slice(0, 6);
      digits.forEach(function (d, i) { d.value = s[i] || ''; });
      (digits[Math.min(s.length, 5)] || digits[5]).focus();
      if (s.length === 6) otpForm.requestSubmit ? otpForm.requestSubmit() : verify();
    }
    digits.forEach(function (d, i) {
      d.addEventListener('input', function () {
        var val = d.value.replace(/\D/g, '');
        if (val.length > 1) return fill(val); // autofill / paste into one box
        d.value = val;
        if (val && digits[i + 1]) digits[i + 1].focus();
        if (code().length === 6) otpForm.requestSubmit ? otpForm.requestSubmit() : verify();
      });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' && !d.value && digits[i - 1]) { digits[i - 1].focus(); digits[i - 1].value = ''; }
        if (e.key === 'ArrowLeft' && digits[i - 1]) digits[i - 1].focus();
        if (e.key === 'ArrowRight' && digits[i + 1]) digits[i + 1].focus();
      });
      d.addEventListener('paste', function (e) {
        e.preventDefault();
        fill((e.clipboardData || window.clipboardData).getData('text'));
      });
    });

    function startTimer(seconds) {
      clearInterval(timer);
      expiresAt = Date.now() + seconds * 1000;
      resendAt = Date.now() + 60 * 1000;
      tick();
      timer = setInterval(tick, 1000);
    }
    function tick() {
      var left = Math.max(0, Math.round((expiresAt - Date.now()) / 1000));
      var m = Math.floor(left / 60);
      var s = left % 60;
      timerEl.innerHTML = left > 0
        ? 'Code expires in <strong>' + m + ':' + (s < 10 ? '0' : '') + s + '</strong>'
        : '<strong>Your code has expired.</strong> Tap “Resend code” for a new one.';
      var wait = Math.max(0, Math.round((resendAt - Date.now()) / 1000));
      resendBtn.disabled = wait > 0;
      resendBtn.textContent = wait > 0 ? 'Resend code in ' + wait + 's' : 'Resend code';
      if (left === 0 && wait === 0) clearInterval(timer);
    }

    function verify() {
      showAlert(otpAlert, '');
      if (code().length !== 6) return showAlert(otpAlert, 'Please enter all 6 digits.');
      verifyBtn.disabled = true;
      verifyBtn.textContent = 'Verifying…';
      post('/reviews/verify', { id: reviewId, code: code() }).then(function (res) {
        clearInterval(timer);
        show('done');
        root.querySelector('[data-mxr-done-title]').focus();
        insertCard(res.review);
        form.reset();
        paint(0);
        word.textContent = '';
        files.forEach(function (f) { URL.revokeObjectURL(f.url); });
        files = [];
        renderPreviews();
      }).catch(function (err) {
        showAlert(otpAlert, err.message);
        if (err.status === 410 && /submit your review again/i.test(err.message)) setTimeout(function () { show('form'); }, 2500);
        digits.forEach(function (d) { d.value = ''; });
        digits[0].focus();
      }).then(function () {
        verifyBtn.disabled = false;
        verifyBtn.textContent = 'Verify and publish';
      });
    }
    otpForm.addEventListener('submit', function (e) { e.preventDefault(); verify(); });

    resendBtn.addEventListener('click', function () {
      showAlert(otpAlert, '');
      resendBtn.disabled = true;
      post('/reviews/resend', { id: reviewId }).then(function (res) {
        startTimer(res.expiresIn || 600);
        showAlert(otpAlert, '');
        digits.forEach(function (d) { d.value = ''; });
        digits[0].focus();
      }).catch(function (err) { showAlert(otpAlert, err.message); tick(); });
    });

    root.querySelector('[data-mxr-back]').addEventListener('click', function () {
      clearInterval(timer);
      show('form');
    });

    function insertCard(r) {
      var list = root.querySelector('[data-mxr-list]');
      if (!list || !r) return;
      var stars = '';
      for (var i = 1; i <= 5; i++) stars += '<svg' + (i > r.rating ? ' class="is-off"' : '') + ' viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' + STAR + '</svg>';
      var media = (r.media || []).map(function (m, i) {
        var inner = m.type === 'video'
          ? '<video src="' + esc(m.url) + '#t=0.5" muted playsinline preload="metadata"></video><span class="mxv-thumb__play">' + ICON_PLAY + '</span>'
          : '<img src="' + esc(m.url) + '" alt="Customer photo" loading="lazy" width="76" height="76">';
        return '<li><button type="button" class="mxv-thumb" data-mxv-open="' + esc(m.url) + '" data-mxv-type="' + esc(m.type) + '" aria-label="Open ' + (m.type === 'video' ? 'video' : 'photo') + ' ' + (i + 1) + '">' + inner + '</button></li>';
      }).join('');
      var when = new Date(r.verified_at).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' });
      var html = '<article class="mxv-card mxv-card--new">' +
        '<header class="mxv-card__head"><span class="mxv-card__avatar" aria-hidden="true">' + esc(r.name.charAt(0).toUpperCase()) + '</span>' +
        '<div class="mxv-card__who"><span class="mxv-card__name">' + esc(r.name) + '</span><span class="mxv-card__meta">' + esc(r.city) + ' · <time datetime="' + esc(r.verified_at) + '">' + esc(when) + '</time></span></div></header>' +
        '<div class="mxv-card__row"><span class="mxv-stars" role="img" aria-label="' + r.rating + ' out of 5 stars">' + stars + '</span>' +
        (r.verified_buyer
          ? '<span class="mxv-badge mxv-badge--buyer" title="Email verified, and this email placed an order for this piece">' + ICON_SHIELD + ' Verified buyer</span></div>'
          : '<span class="mxv-badge" title="Verified with a one-time code sent to the reviewer\'s email">' + ICON_SHIELD + ' Email verified</span></div>') +
        '<p class="mxv-card__body">' + esc(r.body) + '</p>' +
        (media ? '<ul class="mxv-card__media" role="list">' + media + '</ul>' : '') +
        '</article>';
      list.insertAdjacentHTML('afterbegin', html);
    }
  }

  /* ---------------- read more, show more, lightbox (shared) ---------------- */
  function initClamp(scope) {
    scope.querySelectorAll('[data-mxv-body]:not([data-clamp-init])').forEach(function (p) {
      p.setAttribute('data-clamp-init', '1');
      if (p.textContent.length < 320) return;
      p.classList.add('is-clamped');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mxv-link';
      b.textContent = 'Read more';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = p.classList.toggle('is-clamped');
        b.textContent = open ? 'Read more' : 'Show less';
        b.setAttribute('aria-expanded', String(!open));
      });
      p.insertAdjacentElement('afterend', b);
    });
  }

  var lightbox;
  function openLightbox(url, type) {
    if (!lightbox) {
      lightbox = document.createElement('dialog');
      lightbox.className = 'mxv-lightbox';
      lightbox.setAttribute('aria-label', 'Customer photo or video');
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) lightbox.close(); });
      lightbox.addEventListener('close', function () { lightbox.innerHTML = ''; });
      document.body.appendChild(lightbox);
    }
    var media = type === 'video'
      ? '<video src="' + esc(url) + '" controls autoplay playsinline></video>'
      : '<img src="' + esc(url) + '" alt="Customer photo">';
    lightbox.innerHTML = '<button type="button" class="mxv-lightbox__close" aria-label="Close">' + ICON_X + '</button>' + media;
    lightbox.querySelector('.mxv-lightbox__close').addEventListener('click', function () { lightbox.close(); });
    if (lightbox.showModal) lightbox.showModal(); else window.open(url, '_blank');
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mxv-open]');
    if (t) { e.preventDefault(); openLightbox(t.getAttribute('data-mxv-open'), t.getAttribute('data-mxv-type')); return; }
    var more = e.target.closest('[data-mxv-show-more]');
    if (more) {
      var scope = more.closest('.mxv-root');
      var step = parseInt(more.dataset.step || '6', 10);
      var hidden = scope.querySelectorAll('[data-mxv-more][hidden]:not([data-filtered])');
      Array.prototype.slice.call(hidden, 0, step).forEach(function (c) { c.hidden = false; c.removeAttribute('data-mxv-more'); });
      if (scope.querySelectorAll('[data-mxv-more][hidden]:not([data-filtered])').length === 0) more.parentElement.hidden = true;
    }
  });

  /* ---------------- reviews wall tabs ---------------- */
  function initWall(root) {
    if (root.dataset.mxwInit) return;
    root.dataset.mxwInit = '1';
    var tabs = root.querySelectorAll('[role="tab"]');
    var cards = root.querySelectorAll('.mxv-card');
    var empty = root.querySelector('[data-mxw-empty]');
    var emptyName = root.querySelector('[data-mxw-empty-name]');
    var moreWrap = root.querySelector('[data-mxw-more]');
    var perPage = parseInt(root.dataset.perPage || '12', 10);

    tabs.forEach(function (tab) {
      var cat = tab.dataset.cat;
      var n = cat === 'all' ? cards.length : root.querySelectorAll('.mxv-card[data-cats~="' + cat + '"]').length;
      var countEl = tab.querySelector('.mxw-tab__count');
      if (countEl) countEl.textContent = n;
    });

    function select(tab) {
      var cat = tab.dataset.cat;
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
      var shown = 0;
      cards.forEach(function (c) {
        var match = cat === 'all' || (' ' + c.dataset.cats + ' ').indexOf(' ' + cat + ' ') > -1;
        if (!match) { c.hidden = true; c.setAttribute('data-filtered', ''); c.removeAttribute('data-mxv-more'); return; }
        c.removeAttribute('data-filtered');
        shown++;
        if (shown > perPage) { c.hidden = true; c.setAttribute('data-mxv-more', ''); } else { c.hidden = false; c.removeAttribute('data-mxv-more'); }
      });
      if (empty) { empty.hidden = shown > 0; if (emptyName) emptyName.textContent = tab.dataset.name; }
      if (moreWrap) moreWrap.hidden = shown <= perPage;
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var next = e.key === 'ArrowRight' ? tabs[i + 1] || tabs[0] : e.key === 'ArrowLeft' ? tabs[i - 1] || tabs[tabs.length - 1] : null;
        if (next) { e.preventDefault(); next.focus(); select(next); }
      });
    });
    var initial = root.querySelector('[role="tab"][aria-selected="true"]') || tabs[0];
    if (initial) select(initial);
  }

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mxr]').forEach(initReviews);
    (scope || document).querySelectorAll('[data-mxw]').forEach(initWall);
    initClamp(scope || document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
